
import { Component, Vue } from 'vue-property-decorator';
import modulePopup from './modulePopup.vue';
import modalDialog from '@/components/modals/ModalDialog.vue';
import { mapState, mapGetters } from 'vuex';
import VcvBillingLock from '@/routes_new/inner/billing/VcvBillingLock.vue';
import Trigger from '@/components/shared/Trigger.vue';

@Component({
  name: 'vmodules',
  components: {
    modulePopup,
    modalDialog,
    VcvBillingLock,
    Trigger
  },
  computed: {
    ...mapState('company_new', ['rates']),
    ...mapGetters('company_new', ['isFeatureDisabledByTariff']),
    ...mapGetters('process', ['getProcessName'])
  }
})
export default class Vmodules extends Vue {
  private selectedModule: any = null;
  private isPopupVisible: boolean = false;
  private isConfirmationEnabled: boolean = false;
  private hasButton: boolean = true;
  private modulesWithDescription = ['landing', 'survey', 'test', 'integration', 'videointerview'];
  private hasVideoArray = ['survey', 'test', 'tests', 'videointerview'];
  getProcessName!: string;
  isFeatureDisabledByTariff!: any;
  rates!: any;

  get vacancy() {
    return this.$store.getters[`vacancy_new/item`];
  }

  get modules() {
    return this.$store.getters[`vacancy_new/modules/list`];
  }

  get editedModules() {
    if (!this.modules || !this.modules.length) {
      return [];
    }
    let modulesArray = [...this.modules].map(item => {
      let newItem = Object.assign({}, item);
      if (item.id === 'talentq') {
        newItem = Object.assign({}, item, {
          parent_module_id: 'test'
        });
      }
      return newItem;
    });

    return modulesArray;
  }

  get sortingModules() {
    if (!this.editedModules || !this.editedModules.length) {
      return [];
    }
    let modulesArray = [...this.editedModules];

    modulesArray.sort((a, b) => {
      var aIndex = 0;
      var bIndex = 0;
      if (a.id === 'survey') {
        aIndex = -4;
      } else if (a.id === 'test') {
        aIndex = -3;
      } else if (a.id === 'integration') {
        aIndex = -2;
      } else if (a.id === 'talentq') {
        aIndex = -1;
      }
      if (b.id === 'survey') {
        bIndex = -4;
      } else if (b.id === 'test') {
        bIndex = -3;
      } else if (a.id === 'integration') {
        aIndex = -2;
      } else if (b.id === 'talentq') {
        bIndex = -1;
      }

      return aIndex - bIndex;
    });

    modulesArray.unshift({
      id: 'landing',
      name: this.$tr('vacancy.preferences.settings.landing'),
      is_active: true,
      is_enabled: true,
      is_new: false,
      disabled: true,
      parent_module_id: null
    });

    return modulesArray;
  }
  get subModules() {
    if (!this.sortingModules || !this.sortingModules.length) {
      return [];
    }

    return this.sortingModules
      .filter(item => item.parent_module_id === null)
      .map(item => {
        return Object.assign({}, item, {
          name: this.$tr(`vacancy.settings.modules.${item.id}`)
        });
      })
      .map(item => {
        return Object.assign(item, {
          child_modules: []
        });
      });
  }

  get parentModules() {
    if (!this.subModules || !this.subModules.length) {
      return [];
    }

    let subModules = [...this.subModules];

    this.sortingModules.forEach(item => {
      if (item.parent_module_id) {
        let parent_index = null;

        subModules.forEach((new_module, index) => {
          if (new_module.id === item.parent_module_id) {
            parent_index = index;
          }
        });

        subModules[parent_index].child_modules.push(item);
      }
    });

    return subModules;
  }

  get popupTitle() {
    return this.$tr(`vacancy.modules.${this.selectedModule.id}.title`);
  }

  get popupText() {
    return this.$tr(`vacancy.modules.${this.selectedModule.id}.text`);
  }

  get hasPopupVideo() {
    if (!this.selectedModule) {
      return false;
    }
    return !!this.hasVideoArray.find(item => item === this.selectedModule.id);
  }

  public hasDescription(item) {
    if (!item) {
      return false;
    }

    return !!this.modulesWithDescription.find(module => module === item.id);
  }

  public set_is_active(id, v) {
    const is_parent_module = !!this.parentModules.find(parent_module => parent_module.id === id);
    if (!v) {
      let modules = this.parentModules.filter(i => i.is_active === true);
      if (modules.length <= 2 && is_parent_module) {
        this.$noty.error(this.$tr('vacancy.basic.form.modules.informers.cant_deactivate'));
        return false;
      }
    }
    let data = {};
    data.vacancy_id = this.vacancy.id;
    data.value = {
      id,
      is_active: v
    };
    this.$store
      .dispatch('vacancy_new/modules/save', data)
      .then(() => {
        this.$noty.success(this.$tr('vacancy.basic.form.modules.test.informers.save_success'));
        if (is_parent_module && v === false) {
          const currentModule = this.parentModules.find(parent_module => parent_module.id === id);

          currentModule.child_modules.forEach(child_module => {
            if (child_module.id === 'survey-cut') {
              return;
            }
            let childData = {};
            childData.vacancy_id = this.vacancy.id;
            childData.value = {
              id: child_module.id,
              is_active: false
            };
            this.$store.dispatch('vacancy_new/modules/save', childData);
          });
        }
      })
      .then(() => {
        return this.$store.dispatch('vacancy_new/modules/loadSilent', this.vacancy.id);
      })
      .catch(e => {
        this.$noty.error(e.message);
      });
  }

  public showPopup(model, hasButton = true) {
    this.selectedModule = model;
    this.hasButton = hasButton;
    this.togglePopupVisible(true);
  }

  public close() {
    this.togglePopupVisible(false);
  }

  public sendRequest() {
    this.$store
      .dispatch('companyModules/requestModulePayment', {
        id: this.selectedModule.id === 'tests' ? 'test' : this.selectedModule.id
      })
      .then(() => {
        this.togglePopupVisible(false);
        this.toggleModalConfirmation(true);
      })
      .catch(e => {
        this.$noty.error(e.message + '.');
      });
  }

  public togglePopupVisible(val) {
    this.isPopupVisible = val;

    if (!val) {
      this.selectedModule = null;
    }
  }

  public toggleModalConfirmation(val) {
    this.isConfirmationEnabled = val;
  }

  public getChildModulesList(item) {
    if (!item.child_modules || !item.child_modules.length) {
      return '';
    }

    let modulesString = '';
    item.child_modules
      .filter(child_module => child_module.is_enabled && child_module.is_active)
      .forEach((child_module, index) => {
        if (index === 0) {
          modulesString += child_module.name;
        } else {
          modulesString += `, ${child_module.name}`;
        }
      });

    return modulesString;
  }
}
